import {
  BiomarkerPanelType,
  PanelDropdownItemDto
} from '@oncolens/oncolens-ui/lib/components/BiomarkerResults/BiomarkerResults.api';
import { nanoid } from 'nanoid';
import { FaPlusCircle } from 'react-icons/fa';
import useRequestFormStore from '../store';
import { useBiomarkerContext } from './PatientBiomarkerForm';

const AddBiomarkerPanelButton = () => {
  const context = useBiomarkerContext();
  const handleAddTest = () => {
    const store = useRequestFormStore.getState();
    // prefill when single disease in case
    const hasSingleDisease = store.diseases && Object.values(store.diseases).length === 1;
    const firstDisease = hasSingleDisease ? (Object.values(store.diseases)[0] as any) : null;
    const id = nanoid();

    context.setBiomarkerPanels((panelItems) => {
      const unsortedItems = [
        ...panelItems.slice(),
				{
				  type: BiomarkerPanelType.Panel,
				  panel: {
				    id,
				    panelName: undefined,
				    cancerLocationId: hasSingleDisease ? firstDisease.cancerLocationId : '',
				    cancerPathologyId: hasSingleDisease ? firstDisease.cancerPathologyId : '',
				    cancerTypeId: hasSingleDisease ? firstDisease.cancerTypeId : '',
				    cancerPathologyOtherComments: hasSingleDisease
				      ? firstDisease.cancerPathologyOtherComments
				      : '',
				    biomarkers: []
				  }
				} as PanelDropdownItemDto
      ];

      return unsortedItems;
    });

    context.setActiveIds((previous) => ({
      ...previous,
      selectedPanelId: id,
      isEditingPanel: true
    }));
  };

  // We only want to show the 'add panel' button if there are no panels, or if there's not any actively editing forms
  return (
    <>
      {(context.biomarkerPanels.length === 0 ||
				(!context.activeIds.isEditingPanel && !context.activeIds.biomarkerId)) && (
        <button
          data-cy="button-add-biomarker-panel"
          type="button"
          className="flex items-center justify-center w-full p-8 text-gray-600 transition-colors duration-200 bg-gray-100 border-2 border-gray-300 border-dashed rounded-md hover:bg-white hover:border-gray-400"
          onClick={() => {
            handleAddTest();
          }}
        >
          <FaPlusCircle className="mr-2" /> Add biomarker panel...
        </button>
      )}
    </>
  );
};

export { AddBiomarkerPanelButton as default };
